export const CST = {
	SCENES: {
		BOOT: 'BOOT',
		PRELOAD: 'PRELOAD',
		POPUP: 'POPUP',
		MENU: 'MENU',
		FORM: 'FORM',
		INTRO: 'INTRO',
		MAIN_STORYBOARD: 'MAIN_STORYBOARD',
		MAIN_QUESTIONS: 'MAIN_QUESTIONS',
		UISCENE: 'UISCENE',
		STORY_SELECT: 'STORY_SELECT',
		STORYBOARD_1: 'STORYBOARD_1',
		STORYBOARD_2: 'STORYBOARD_2',
		STORYBOARD_3: 'STORYBOARD_3',
		STORYBOARD_4: 'STORYBOARD_4',
		STORYBOARD_5: 'STORYBOARD_5',
		STORYBOARD_6: 'STORYBOARD_6',
		STORYBOARD_7: 'STORYBOARD_7',
		PAIRS: 'PAIRS',
		PAIRS2: 'PAIRS2',
		BRICKS: 'BRICKS',
		TICTACTOE: 'TICTACTOE',
		SIMONSAYS: 'SIMONSAYS',
		RULES: 'RULES',
		OUTRO: 'OUTRO',
		SUS: 'SUS',
		ENDSCREEN: 'ENDSCREEN',
		END: 'END',
		CREDITS: 'CREDITS',
	},
	TEXTSTYLES: {
		TITLESTYLE: {
			fontFamily: 'Arial',
			fontSize: '50px',
			color: '#000',
			fontStyle: 'bold',
		},
		TEAMNAME: {
			fontFamily: 'Arial',
			fontSize: '25px',
			color: '#000',
			fontStyle: 'bold',
		},
		POINTS: {
			fontFamily: 'Arial',
			fontSize: '25px',
			color: '#000',
			fontStyle: 'bold',
		},
		TEAMLEADERBOARD: {
			fontFamily: 'Arial',
			fontSize: '40px',
			color: '#000',
		},
		BUTTONSSTYLE: {
			fontFamily: 'Arial',
			fontSize: '32px',
			color: '#fff',
		},
		QUESTIONSTYLE: {
			fontFamily: 'Arial',
			fontSize: '32px',
			color: '#000',
			wordWrap: {
				width: 1025,
			},
		},
		TIMERSTYLE: {
			fontFamily: 'Arial',
			fontSize: '66px',
			color: '#000',
		},
		TIMERSTYLEMAGIC: {
			fontFamily: 'Arial',
			fontSize: '66px',
			color: '#000',
		},
		STORY_SELECT: {
			fontFamily: 'Arial',
			fontStyle: 'bold',
			fontSize: '40px',
			color: '#fff',
			shadow: {
				color: '#000000',
				fill: true,
				offsetX: 2,
				offsetY: 2,
				blur: 4,
			},
		},
	},
};
